// extracted by mini-css-extract-plugin
export default {"root":"ListingSkeleton-root","imageSkeleton":"ListingSkeleton-imageSkeleton"};